module.exports = __webpack_public_path__ + "img/mlh-removebg.30b3691e.png";